import { render, staticRenderFns } from "./loginMovieBg.vue?vue&type=template&id=65a6dcfd&scoped=true"
import script from "./loginMovieBg.vue?vue&type=script&lang=js"
export * from "./loginMovieBg.vue?vue&type=script&lang=js"
import style0 from "./loginMovieBg.vue?vue&type=style&index=0&id=65a6dcfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6dcfd",
  null
  
)

export default component.exports